export const Logo = () => (
  <svg width="152" height="25" viewBox="0 0 152 25">
    <g>
      <path
        d="M73.5399 24.2411C73.1407 24.1806 72.7819 24.0998 72.4224 23.9989C71.6448 23.7768 70.9266 23.4739 70.2683 23.0903C70.2285 23.0701 67.257 21.0711 66.2792 20.7885C65.1225 20.4452 63.8859 20.3645 62.6293 20.5462C61.4525 20.7077 60.3555 21.1115 59.3383 21.7172C59.0989 21.8586 58.8396 22.0403 58.6202 22.222C58.361 22.4037 58.1017 22.5854 57.8224 22.7268C56.9449 23.2518 56.0074 23.6556 55.0101 23.9181C54.9702 23.9181 54.9503 23.9383 54.9103 23.9383C54.8904 23.8777 54.8705 23.797 54.8505 23.7162C54.8107 23.4133 54.8705 23.1306 55.03 22.8883C55.9475 21.5961 57.0645 20.5462 58.3211 19.7991C59.4779 19.1126 60.7345 18.628 62.0509 18.4059C62.1706 18.3857 62.2902 18.3655 62.4099 18.3453C64.0854 18.103 65.7605 18.2645 67.3562 18.8501C67.6158 18.9308 67.8951 19.052 68.154 19.1731C69.0321 19.5568 69.8495 20.0616 70.6076 20.6875C70.6872 20.7481 70.7674 20.8087 70.8268 20.8894C70.8268 20.8894 70.8268 20.8894 70.847 20.8894C71.5052 21.4548 72.1034 22.1008 72.6025 22.8076C72.9613 23.272 73.2803 23.7364 73.5399 24.2411Z"
        fill="#CEE3DA"
      />
      <path
        d="M7.5195 15.357H2.15413V3.04044H7.55942C8.43704 3.04044 9.25478 3.22216 9.99279 3.54522C10.7307 3.88847 11.4089 4.35286 11.9475 4.95859C12.486 5.54414 12.8849 6.21045 13.1841 6.93736C13.4832 7.6642 13.6229 8.4315 13.6229 9.21894C13.6229 10.0064 13.4832 10.7938 13.1841 11.5207C12.8849 12.2476 12.466 12.9139 11.9475 13.4591C11.389 14.0446 10.7307 14.509 9.99279 14.8321C9.23481 15.1753 8.39712 15.357 7.5195 15.357ZM15.1587 5.98834C14.7398 4.97879 14.1614 4.07019 13.4035 3.30292C12.6456 2.53566 11.7679 1.92992 10.7507 1.48572C9.73348 1.0617 8.65643 0.8396 7.5195 0.8396H1.07707C0.777881 0.8396 0.518587 0.94056 0.31913 1.14247C0.119674 1.34438 0 1.60687 0 1.92992V23.0499C0 23.3528 0.0997283 23.5951 0.279239 23.8171C0.478696 24.0392 0.737989 24.1402 1.07707 24.1402C1.37625 24.1402 1.63555 24.0392 1.835 23.8171C2.03446 23.6152 2.15413 23.3528 2.15413 23.0499V17.5175H7.47964C8.61651 17.5175 9.69362 17.2954 10.7108 16.8916C11.7281 16.4676 12.6256 15.882 13.3836 15.1147C14.1415 14.3475 14.7199 13.4591 15.1387 12.4495C15.5576 11.4399 15.777 10.3497 15.777 9.21894C15.797 8.10841 15.5776 7.01808 15.1587 5.98834Z"
        fill="#2C2B4F"
      />
      <path
        d="M27.9239 14.509H22.5984V3.02029H28.0037C28.8614 3.02029 29.6792 3.18182 30.4371 3.48469C30.7961 3.62602 31.1153 3.80775 31.4144 4.00965C31.7734 4.23176 32.0926 4.49425 32.3917 4.79711C32.4117 4.81731 32.4317 4.8375 32.4516 4.85769C32.9502 5.38266 33.3491 6.00858 33.6483 6.6951C33.9475 7.40174 34.0872 8.16904 34.0872 8.93628C34.0872 9.70358 33.9475 10.4304 33.6284 11.0967C33.3292 11.7833 32.9104 12.3688 32.3718 12.8736C31.8134 13.3783 31.1751 13.7822 30.4172 14.0648C29.6592 14.3677 28.8215 14.509 27.9239 14.509ZM31.2549 16.084C32.671 15.5388 33.8478 14.6908 34.7254 13.5399C35.2041 12.914 35.603 12.2073 35.8623 11.4198C36.1216 10.6525 36.2612 9.8045 36.2612 8.93628C36.2612 8.12865 36.1416 7.34121 35.9221 6.59411C35.8423 6.31144 35.7426 6.02877 35.6229 5.76629C35.2041 4.79711 34.6257 3.94908 33.8877 3.2222L33.8278 3.16163C33.4887 2.81838 33.1098 2.5357 32.7109 2.25303C32.2322 1.92997 31.7336 1.66748 31.1751 1.42519C30.497 1.14252 29.7589 0.960794 29.0209 0.88003C28.6819 0.839649 28.3428 0.819458 27.9838 0.819458H21.5413C21.2421 0.819458 20.9829 0.920412 20.7834 1.12233C20.5839 1.32423 20.4642 1.60691 20.4642 1.90978V23.0095C20.4642 23.3124 20.564 23.5749 20.7834 23.7768C20.9829 23.9787 21.2621 24.0998 21.5413 24.0998C21.8405 24.0998 22.0998 23.9989 22.2993 23.7768C22.4987 23.5749 22.6184 23.3124 22.6184 23.0095V16.6695H27.9239C28.283 16.6695 28.622 16.6493 28.9411 16.6089L34.2866 23.7364C34.7254 24.1604 35.3637 24.1604 35.7027 23.8373C35.982 23.6354 36.1416 23.3326 36.1416 22.9691C36.1416 22.6663 36.0418 22.4038 35.8423 22.2221L31.2549 16.084Z"
        fill="#2C2B4F"
      />
      <path
        d="M51.9186 22.1614C50.1833 22.1614 48.5676 21.7172 47.1116 20.849C45.6955 20.001 44.5387 18.8299 43.7209 17.3762C42.8632 15.9022 42.4244 14.2667 42.4244 12.5101C42.4244 11.2179 42.6637 9.94579 43.1624 8.77474C43.6411 7.60362 44.3392 6.55371 45.1968 5.6653C45.4162 5.4432 45.6357 5.24129 45.875 5.03938C45.8949 5.03938 45.8949 5.01919 45.9149 4.999C46.1343 4.81727 46.3736 4.63556 46.593 4.47402C47.1116 4.13077 47.6502 3.8279 48.2286 3.58561C49.3854 3.10102 50.6221 2.83854 51.9186 2.83854C53.195 2.83854 54.4317 3.08083 55.5885 3.58561C56.7454 4.0702 57.7826 4.77689 58.6801 5.6653C59.5577 6.55371 60.2558 7.60362 60.7345 8.79494C61.2332 9.96599 61.4725 11.2179 61.4725 12.5101C61.4725 14.2667 61.0337 15.9022 60.176 17.3762C59.7372 18.103 59.2187 18.7693 58.6602 19.3347C57.5033 20.526 56.0672 21.374 54.4516 21.8384C53.6139 22.0403 52.7762 22.1614 51.9186 22.1614ZM62.2105 6.85658C62.1706 6.73546 62.1108 6.63448 62.031 6.51333C61.5323 5.64511 60.914 4.83746 60.196 4.13077C59.8569 3.78752 59.4979 3.46446 59.1189 3.1616C59.079 3.14141 59.0391 3.10102 58.9992 3.08083C58.6203 2.77797 58.2413 2.51548 57.8424 2.27319C56.9648 1.74822 56.0273 1.3444 55.0301 1.08191C54.9303 1.06172 54.8107 1.02134 54.7109 1.00115C53.7735 0.758852 52.856 0.657898 51.9186 0.657898C51.1207 0.657898 50.3229 0.738661 49.545 0.900194H49.525C48.2884 1.14248 47.1116 1.60688 45.9947 2.27319C45.6955 2.45491 45.3963 2.65682 45.0972 2.87892C44.9774 2.97988 44.8378 3.08083 44.6982 3.18179C44.3192 3.48466 43.9802 3.78752 43.6411 4.13077C42.943 4.83746 42.3247 5.64511 41.826 6.51333C41.7662 6.61428 41.7064 6.71527 41.6664 6.83638C41.6664 6.83638 41.6664 6.85658 41.6465 6.85658C40.709 8.59303 40.2503 10.491 40.2503 12.4899C40.2503 13.5601 40.3899 14.6302 40.6492 15.6195C40.9285 16.6291 41.3075 17.5983 41.826 18.4665C42.3247 19.3549 42.943 20.1626 43.661 20.8692C44.3591 21.5961 45.157 22.222 45.9947 22.7066C46.8723 23.2316 47.8097 23.6354 48.807 23.8979C49.8043 24.1806 50.8414 24.3219 51.8986 24.3219C52.9158 24.3219 53.9131 24.1806 54.8904 23.9181C54.9303 23.9181 54.9503 23.8979 54.9901 23.8979C55.9875 23.6354 56.9449 23.2114 57.8025 22.7066C58.0817 22.5451 58.341 22.3836 58.6003 22.2018C59.1588 21.798 59.6973 21.3538 60.196 20.849C60.914 20.1222 61.5523 19.2943 62.0709 18.3857C62.5496 17.5175 62.9485 16.6089 63.2277 15.6195C63.487 14.61 63.6466 13.5399 63.6466 12.4697C63.6266 10.5112 63.1479 8.61323 62.2105 6.85658Z"
        fill="#2C2B4F"
      />
      <path
        d="M82.3957 17.3156C82.3957 18.3655 82.1961 19.3347 81.7773 20.2029C81.3585 21.0711 80.8 21.8384 80.0818 22.4643C79.3838 23.07 78.5657 23.5345 77.6485 23.8575C76.7306 24.1806 75.7932 24.3421 74.8362 24.3421C74.3776 24.3421 73.9385 24.3017 73.5197 24.2411C73.1205 24.1806 72.7617 24.0998 72.4029 23.9989C71.6246 23.7768 70.907 23.4739 70.2488 23.0902C70.209 23.07 70.1685 23.0499 70.1287 23.0095C69.7099 22.747 69.3113 22.4441 68.9519 22.121C68.7927 21.9797 68.6329 21.8182 68.4933 21.6768C67.9949 21.1317 67.6158 20.526 67.3562 19.9C67.2766 19.6981 67.2368 19.5164 67.2368 19.3549C67.2368 19.1731 67.2766 19.0116 67.3764 18.8703C67.6354 18.951 67.9146 19.0722 68.1743 19.1731C69.0517 19.5568 69.8697 20.0616 70.6278 20.6875C70.8868 20.9096 71.1862 21.1115 71.5052 21.2932C72.562 21.8787 73.6991 22.1816 74.9157 22.1816C75.5544 22.1816 76.2126 22.0807 76.8702 21.8586C77.5089 21.6567 78.0673 21.3538 78.5657 20.95C79.0843 20.526 79.5032 20.0212 79.8026 19.4154C80.102 18.8097 80.2416 18.1232 80.2416 17.3762C80.2416 16.1647 79.6825 15.1955 78.5461 14.4282C78.0673 14.1052 77.5089 13.8225 76.9107 13.5802C76.2922 13.3379 75.514 13.035 74.5967 12.712C72.7819 12.2476 71.286 11.6217 70.1887 10.8342C68.6727 9.74387 67.9146 8.35071 67.9146 6.65465C67.9146 6.5335 67.9146 6.39216 67.9348 6.25082C67.9949 5.48356 68.1945 4.77687 68.5331 4.11056C68.8521 3.54521 69.2311 3.04043 69.6903 2.59623C69.8495 2.45488 70.0093 2.31355 70.1887 2.17221C70.4079 2.01068 70.6474 1.84915 70.8868 1.70781C71.3454 1.42514 71.8444 1.20304 72.3826 1.02131C73.1805 0.758832 74.0181 0.617493 74.8159 0.617493C76.2524 0.617493 77.5487 0.900168 78.6857 1.48571C79.8424 2.07125 80.74 2.93948 81.3983 4.04998C81.4778 4.13075 81.5176 4.29228 81.5176 4.49419C81.5176 4.77687 81.3983 5.01916 81.1791 5.26146C80.7002 5.66528 80.1418 5.60471 79.7628 5.24127C79.0843 4.33266 78.3667 3.72693 77.5689 3.3433C76.7711 2.97986 75.8336 2.77794 74.8159 2.77794C74.2777 2.77794 73.7193 2.85871 73.1609 3.02024C72.6025 3.18177 72.1034 3.42406 71.665 3.72693C71.1862 4.07018 70.787 4.474 70.5078 4.95859C70.2285 5.42298 70.0889 5.96815 70.0694 6.57388C70.0694 7.68439 70.6474 8.57281 71.8444 9.25933C72.303 9.52176 72.7819 9.76406 73.3005 9.94577C73.8191 10.1275 74.4369 10.3295 75.195 10.5516C76.3118 10.9554 77.2695 11.3188 78.0073 11.6418C78.7856 11.9851 79.5032 12.3889 80.102 12.8331C80.8196 13.3783 81.378 14.0244 81.7773 14.7311C82.1961 15.4983 82.3957 16.3666 82.3957 17.3156Z"
        fill="#2C2B4F"
      />
      <path
        d="M106.071 19.3549C106.27 19.5568 106.39 19.8193 106.39 20.1222C106.39 20.4452 106.29 20.7077 106.091 20.9096C104.954 22.0605 103.638 22.949 102.241 23.5143C100.826 24.0796 99.3291 24.3825 97.7934 24.3825C95.6993 24.3825 93.7247 23.8373 91.9098 22.7672C91.0519 22.2625 90.2541 21.6365 89.5561 20.9096C88.858 20.2029 88.2396 19.3751 87.7412 18.5069C86.6837 16.6897 86.1651 14.6705 86.1651 12.5505C86.1651 11.5409 86.3047 10.5112 86.5643 9.5218C86.8233 8.53245 87.2024 7.58351 87.7014 6.71528C88.1796 5.82685 88.7785 5.0192 89.4765 4.29232C90.1543 3.56544 90.9521 2.91932 91.81 2.39436C93.6053 1.26365 95.6596 0.698303 97.8737 0.698303C98.6513 0.698303 99.4289 0.779066 100.187 0.940593H100.207C100.267 0.960783 100.327 0.960783 100.387 0.980974C100.466 1.00117 100.546 1.02136 100.606 1.04155C100.785 1.08193 100.965 1.12232 101.124 1.18289C101.244 1.22327 101.364 1.26365 101.484 1.30403C101.663 1.36461 101.862 1.42518 102.042 1.50595C102.122 1.54633 102.201 1.56652 102.301 1.6069C102.341 1.62709 102.381 1.64728 102.441 1.66747C102.72 1.78862 103.019 1.92996 103.299 2.09149C103.399 2.13187 103.478 2.19245 103.578 2.25302C103.657 2.2934 103.757 2.35397 103.837 2.41455C103.977 2.49531 104.097 2.57608 104.236 2.67703C104.376 2.7578 104.495 2.85875 104.635 2.95971C104.675 3.00009 104.735 3.02028 104.774 3.06067C104.795 3.08086 104.814 3.10105 104.834 3.10105C104.894 3.14143 104.954 3.18181 105.014 3.24238C105.014 3.24238 105.014 3.24238 105.034 3.24238C105.074 3.26257 105.114 3.30295 105.134 3.32315C105.153 3.34334 105.174 3.36353 105.193 3.36353C105.513 3.62601 105.832 3.92888 106.131 4.23175C106.35 4.45386 106.45 4.71634 106.45 4.99901C106.45 5.28169 106.35 5.54417 106.131 5.74609C105.991 5.90761 105.792 6.00857 105.592 6.04895C105.234 5.88742 104.874 5.7057 104.535 5.50379C104.296 5.36245 104.057 5.22112 103.837 5.05959C103.817 5.05959 103.817 5.0394 103.797 5.0192C103.737 4.97882 103.678 4.93844 103.618 4.89806C103.518 4.81729 103.418 4.73653 103.318 4.67595C103.318 4.67595 103.318 4.67595 103.299 4.67595C102.7 4.23175 102.082 3.8885 101.404 3.60582C99.0303 2.59627 96.3772 2.63665 94.1037 3.62601C92.947 4.1308 91.9098 4.81729 91.0519 5.7057C90.1941 6.6143 89.496 7.64403 89.0172 8.81515C88.5188 9.9862 88.2794 11.238 88.2794 12.5505C88.2794 13.8225 88.5188 15.0542 88.9774 16.2253C89.4563 17.3964 90.1145 18.4261 90.9919 19.3146C91.87 20.2231 92.887 20.9298 94.0639 21.4346C95.2205 21.9394 96.4972 22.2019 97.8332 22.2019C99.0903 22.2019 100.287 21.9798 101.424 21.5154C102.541 21.0509 103.578 20.3443 104.535 19.4155C104.954 18.9511 105.652 18.9511 106.071 19.3549Z"
        fill="#2C2B4F"
      />
      <path
        d="M124.002 16.2455H114.009L119.016 4.43368L124.002 16.2455ZM128.989 22.6057L119.993 1.48577C119.814 1.06175 119.475 0.819458 119.016 0.819458C118.577 0.819458 118.238 1.04156 117.998 1.48577L109.023 22.5653C108.963 22.7067 108.923 22.8682 108.923 23.0499C108.923 23.373 109.043 23.6354 109.263 23.8373C109.482 24.0191 109.721 24.12 110 24.12C110.14 24.12 110.28 24.0998 110.399 24.0392C110.659 23.9383 110.858 23.7364 110.998 23.4537L113.112 18.4463H124.9L127.034 23.4941C127.133 23.696 127.273 23.8373 127.453 23.9585C127.632 24.0796 127.832 24.1402 128.051 24.1402C128.231 24.1402 128.39 24.0998 128.53 24.0392C128.909 23.8373 129.108 23.5143 129.108 23.0701C129.088 22.9086 129.049 22.7471 128.989 22.6057Z"
        fill="#2C2B4F"
      />
      <path
        d="M151.068 1.16266C150.689 0.738652 149.912 0.718461 149.493 1.16266C149.293 1.38477 149.194 1.64726 149.194 1.92993V19.7789L134.972 1.24343C134.493 0.718461 133.855 0.69827 133.376 1.12228C133.157 1.3242 133.038 1.60687 133.038 1.92993V23.0297C133.038 23.3326 133.137 23.595 133.357 23.797C133.776 24.221 134.474 24.221 134.872 23.797C135.072 23.595 135.192 23.3326 135.192 23.0297V5.05956L149.413 23.6152L149.493 23.7162L149.672 23.8979C149.832 24.0594 150.012 24.1402 150.231 24.1402H150.47C150.729 24.0998 150.949 23.9787 151.108 23.7768C151.288 23.5749 151.368 23.3326 151.368 23.0499V1.92993C151.348 1.62707 151.248 1.36458 151.068 1.16266Z"
        fill="#2C2B4F"
      />
      <path
        d="M110.678 7.30077C108.505 7.30077 106.251 6.67485 104.276 5.48355C103.697 5.12011 103.498 4.35285 103.857 3.76731C104.216 3.18176 104.974 2.97985 105.553 3.34329C107.667 4.61533 110.14 5.09992 112.374 4.63552C115.605 3.96921 117.2 2.21259 117.859 1.22322C118.238 0.657869 119.016 0.49634 119.574 0.900162C120.133 1.28379 120.292 2.07125 119.893 2.6366C119.016 3.94902 116.941 6.25081 112.852 7.09886C112.154 7.21998 111.417 7.30077 110.678 7.30077Z"
        fill="#6EAF81"
      />
      <path
        d="M57.0047 23.171C56.5659 23.171 56.1471 22.9489 55.9077 22.5451C55.5486 21.9394 55.7481 21.1317 56.3465 20.7683L56.7654 20.5058C58.7599 19.2944 60.196 18.4261 63.3075 18.204C66.5388 17.9819 68.8325 19.254 71.0662 20.7077C71.6651 21.0913 71.8445 21.899 71.4452 22.5047C71.0662 23.1105 70.2684 23.2922 69.6702 22.8884C67.3164 21.374 65.7208 20.6269 63.4671 20.7884C60.9739 20.9702 59.9367 21.5961 58.0618 22.7268L57.643 22.9893C57.4435 23.1307 57.2241 23.171 57.0047 23.171Z"
        fill="#6EAF81"
      />
    </g>
  </svg>
);

export const HomeIcon = () => (
  <svg width="40" height="44" viewBox="0 0 40 44" fill="none">
    <path
      d="M32 18.4982C32 17.0618 20 8 20 8C20 8 8.0001 17.6659 8.0001 18.4982V32.6135C8.0001 34.172 9.07152 35.7895 10.5715 35.7895H29.4286C31.087 35.7895 32 34.172 32 32.6135V18.4982Z"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14.3159 30.7368H25.6843"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg width="40" height="42" viewBox="0 0 40 42" fill="none">
    <path
      d="M20.8 8.3999C20.8 8.3999 14.4 8.39991 10.743 8.3999C8.91434 8.3999 8.0003 8.96115 8.00021 10.2962C7.9999 15.0369 7.99984 23.5703 8.00021 31.1555C8.00029 32.7264 9.22821 33.9999 10.743 33.9999C15.3145 33.9999 20.8 33.9999 20.8 33.9999"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14.4 21.2H30.4"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M25.6 14.7998L32 21.6921L25.6 27.5998"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const DataSetIcon = () => (
  <svg width="36" height="45" viewBox="0 0 36 45" fill="none">
    <path
      d="M8 12.2895C8 11.2895 10.5 8.78949 18 8.78949C25.5 8.78949 28 11.6845 28 12.2895M8 12.2895C8 13.2895 11.7421 15.7895 18 15.7895C24.2579 15.7895 28 13.1101 28 12.2895M8 12.2895C8 15.0232 8 19.7895 8 19.7895M28 12.2895C28 15.0232 28 19.7895 28 19.7895M8 19.7895C8 19.7895 11.5 22.7895 18 22.7895C24.5 22.7895 28 19.7895 28 19.7895M8 19.7895L8 26.7895M28 19.7895V26.7895M8 26.7895C8 26.7895 8.00026 31.2895 8 33.7895C7.99995 34.2895 11 36.7895 18 36.7895C25 36.7895 28 34.494 28 33.7895C28 30.7895 28 26.7895 28 26.7895M8 26.7895C8 26.7895 11 29.7895 18 29.7895C25 29.7895 28 26.7895 28 26.7895"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ModelIcon = () => (
  <svg width="44" height="46" viewBox="0 0 44 46" fill="none">
    <rect
      x="11.3348"
      y="9.78949"
      width="7.9161"
      height="4.99959"
      rx="1"
      stroke="#2C2B4F"
      strokeWidth="2"
    />
    <rect
      x="18.3342"
      y="20.2889"
      width="7.9161"
      height="4.99959"
      rx="1"
      stroke="#2C2B4F"
      strokeWidth="2"
    />
    <rect
      x="24.1664"
      y="31.9543"
      width="7.9161"
      height="4.99959"
      rx="1"
      stroke="#2C2B4F"
      strokeWidth="2"
    />
    <path
      d="M23.4592 12.5811C23.4592 12.5811 29.8755 12.581 33.3753 12.5811C34.5419 12.5811 36.0001 13.456 36.0001 14.9143C36.0001 17.5391 36.0001 18.7057 36.0001 21.0389C36.0001 22.2055 35.1252 22.7888 33.9586 22.7888C32.2087 22.7888 30.1671 22.7888 30.1671 22.7888"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20.5411 34.454C20.5411 34.454 14.1248 34.4541 10.625 34.454C9.45838 34.454 8.00013 33.5791 8.00013 32.1208C8.00013 29.496 8.00013 28.3294 8.00013 25.9962C8.00013 24.8296 8.87508 24.2463 10.0417 24.2463C11.7916 24.2463 13.8331 24.2463 13.8331 24.2463"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M31.6252 20.4553L29.5836 22.4969L31.6252 24.8301"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.4995 36.4955L20.5411 34.454L18.4995 32.1208"
      stroke="#2C2B4F"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const EvaluateIcon = () => (
  <svg width="44" height="46" viewBox="0 0 44 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(10, 6) scale(1.24)">
      <path d="M16 1C17.6569 1 19 2.34315 19 4C19 4.55228 18.5523 5 18 5C17.4477 5 17 4.55228 17 4C17 3.44772 16.5523 3 16 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H16C16.5523 21 17 20.5523 17 20V19C17 18.4477 17.4477 18 18 18C18.5523 18 19 18.4477 19 19V20C19 21.6569 17.6569 23 16 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1H16Z" fill="#2C2B4F"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M20.7991 8.20087C20.4993 7.90104 20.0132 7.90104 19.7133 8.20087L11.9166 15.9977C11.7692 16.145 11.6715 16.3348 11.6373 16.5404L11.4728 17.5272L12.4596 17.3627C12.6652 17.3285 12.855 17.2308 13.0023 17.0835L20.7991 9.28666C21.099 8.98682 21.099 8.5007 20.7991 8.20087ZM18.2991 6.78666C19.38 5.70578 21.1325 5.70577 22.2134 6.78665C23.2942 7.86754 23.2942 9.61999 22.2134 10.7009L14.4166 18.4977C13.9744 18.9398 13.4052 19.2327 12.7884 19.3355L11.8016 19.5C10.448 19.7256 9.2744 18.5521 9.50001 17.1984L9.66448 16.2116C9.76728 15.5948 10.0602 15.0256 10.5023 14.5834L18.2991 6.78666Z" fill="#2C2B4F"/>
      <path d="M5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7Z" fill="#2C2B4F"/>
      <path d="M5 11C5 10.4477 5.44772 10 6 10H10C10.5523 10 11 10.4477 11 11C11 11.5523 10.5523 12 10 12H6C5.44772 12 5 11.5523 5 11Z" fill="#2C2B4F"/>
      <path d="M5 15C5 14.4477 5.44772 14 6 14H7C7.55228 14 8 14.4477 8 15C8 15.5523 7.55228 16 7 16H6C5.44772 16 5 15.5523 5 15Z" fill="#2C2B4F"/>
    </g>
  </svg>
);
export const HelpIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g>
      <path
        d="M11.94 19.2C12.36 19.2 12.7152 19.0548 13.0056 18.7644C13.296 18.474 13.4408 18.1192 13.44 17.7C13.44 17.28 13.2952 16.9248 13.0056 16.6344C12.716 16.344 12.3608 16.1992 11.94 16.2C11.52 16.2 11.1652 16.3452 10.8756 16.6356C10.586 16.926 10.4408 17.2808 10.44 17.7C10.44 18.12 10.5852 18.4752 10.8756 18.7656C11.166 19.056 11.5208 19.2008 11.94 19.2ZM10.86 14.58H13.08C13.08 13.92 13.1552 13.4 13.3056 13.02C13.456 12.64 13.8808 12.12 14.58 11.46C15.1 10.94 15.51 10.4448 15.81 9.9744C16.11 9.504 16.26 8.9392 16.26 8.28C16.26 7.16 15.85 6.3 15.03 5.7C14.21 5.1 13.24 4.8 12.12 4.8C10.98 4.8 10.0548 5.1 9.3444 5.7C8.634 6.3 8.1392 7.02 7.86 7.86L9.84 8.64C9.94 8.28 10.1652 7.89 10.5156 7.47C10.866 7.05 11.4008 6.84 12.12 6.84C12.76 6.84 13.24 7.0152 13.56 7.3656C13.88 7.716 14.04 8.1008 14.04 8.52C14.04 8.92 13.92 9.2952 13.68 9.6456C13.44 9.996 13.14 10.3208 12.78 10.62C11.9 11.4 11.36 11.99 11.16 12.39C10.96 12.79 10.86 13.52 10.86 14.58ZM12 24C10.34 24 8.78 23.6848 7.32 23.0544C5.86 22.424 4.59 21.5692 3.51 20.49C2.43 19.41 1.5752 18.14 0.9456 16.68C0.316 15.22 0.0008 13.66 0 12C0 10.34 0.3152 8.78 0.9456 7.32C1.576 5.86 2.4308 4.59 3.51 3.51C4.59 2.43 5.86 1.5752 7.32 0.9456C8.78 0.316 10.34 0.0008 12 0C13.66 0 15.22 0.3152 16.68 0.9456C18.14 1.576 19.41 2.4308 20.49 3.51C21.57 4.59 22.4252 5.86 23.0556 7.32C23.686 8.78 24.0008 10.34 24 12C24 13.66 23.6848 15.22 23.0544 16.68C22.424 18.14 21.5692 19.41 20.49 20.49C19.41 21.57 18.14 22.4252 16.68 23.0556C15.22 23.686 13.66 24.0008 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.32 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.32 21.6 12 21.6Z"
        fill="#2C2B4F"
      />
    </g>
  </svg>
);

export const SettingsIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g>
      <circle cx="13" cy="13" r="3.5" stroke="#2C2B4F" strokeWidth="2" />
      <path
        d="M14.6315 1.00001H11.2236C9.24962 1.00005 9.81669 3.76091 8.2265 4.89747C5.77103 6.65247 3.88809 3.47217 3.04473 5.00001C2.25212 6.43589 2.16074 7.05128 1.14978 9C0.362393 10.5178 3.17174 11.2239 3.17174 13C3.17174 14.7761 0.32556 15.9756 1.14978 17.5641C2.16088 19.5128 2.03377 19.0513 3.04473 21C3.77271 22.4032 5.65168 20.2213 7.81576 21C9.80757 21.7167 8.43206 25 10.5581 25L14.6315 25C16.7576 25 15.724 22.1324 18.0394 21C20.7657 19.6667 22.091 22.4074 22.8104 21C23.492 19.6667 23.6158 19.6667 24.8552 17.5641C25.7268 16.0855 22.3799 14.7017 22.3799 13C22.3799 11.2983 25.6448 10.522 24.8552 9C24.216 7.76795 23.0862 6.25884 22.3799 4.89747C21.6737 3.5361 20.0841 6.33333 18.0394 5.00001C15.9947 3.66669 16.3971 0.999973 14.6315 1.00001Z"
        stroke="#2C2B4F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const SearchIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
    <g>
      <path
        d="M13.9161 7.62871C13.9161 11.1954 11.0247 14.0868 7.45805 14.0868C3.89137 14.0868 1 11.1954 1 7.62871C1 4.06202 3.89137 1.17065 7.45805 1.17065C11.0247 1.17065 13.9161 4.06202 13.9161 7.62871Z"
        stroke="#969696"
        strokeWidth="2"
      />
      <path
        d="M18 17.8296L12.6213 12.792"
        stroke="#969696"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const UploadIcon = ({ color = "#2C2B4F" }) => (
  <svg width="48" height="46" viewBox="0 0 48 46" fill="none">
    <path d="M8 37.5H40" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path
      d="M25 10.5L25 36.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10 20.5L25 8.5L39 20.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const EditIcon = ({ color = "#2C2B4F" }) => (
  <svg width="32" height="32" viewBox="0 0 38 46" fill="none">
    <g transform="scale(1.2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5257 3.75916H2C0.89543 3.75916 0 4.65458 0 5.75915V29.7384C0 30.843 0.895432 31.7384 2 31.7384H25.9793C27.0838 31.7384 27.9793 30.843 27.9793 29.7384V14.2119C27.6911 14.2379 27.3993 14.2511 27.1044 14.2511C26.7238 14.2511 26.3483 14.229 25.9793 14.186L25.9793 29.7384L2 29.7384L2 5.75916H17.5517C17.5086 5.38984 17.4865 5.01413 17.4865 4.63326C17.4865 4.33861 17.4998 4.04705 17.5257 3.75916Z"
        fill={color}
      />
      <path
        d="M14.4408 20.6079L30.4741 6.11432C30.4741 6.11432 30.9735 3.81261 30.1938 2.74896C29.288 1.51324 26.4302 1.64091 26.4302 1.64091L10.397 16.1345L9.14033 21.5863L14.4408 20.6079Z"
        stroke={color}
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const ChainIcon = ({ color = "#2C2B4F" }) => (
  <svg width="44" height="46" viewBox="0 0 44 46" fill="none">
    <g transform="translate(6, 8) scale(0.94)">
      <circle
        cx="5.18178"
        cy="19.9092"
        r="4.18178"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="13.8185"
        cy="6.09096"
        r="4.18178"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="22.4552"
        cy="19.9092"
        r="4.18178"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="32.8185"
        cy="6.09096"
        r="4.18178"
        stroke={color}
        strokeWidth="2"
      />
      <line
        x1="12.8898"
        y1="10.1454"
        x2="7.70806"
        y2="17.0545"
        stroke={color}
        strokeWidth="2"
      />
      <line
        x1="16.3469"
        y1="8.94541"
        x2="21.5287"
        y2="15.8545"
        stroke={color}
        strokeWidth="2"
      />
      <line
        x1="31.797"
        y1="10.2525"
        x2="24.8879"
        y2="17.1616"
        stroke={color}
        strokeWidth="2"
      />
    </g>
  </svg>
);

export const CloseIcon = ({ color = "#FEFEFE" }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <g>
      <path
        d="M1 1L16.9945 16.9945"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.0059 1L1.00037 16.9945"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const SuccessIcon = () => <img src="/images/SuccessIcon.jpg" alt="" />;
export const BrokenTeethIcon = () => (
  <img src="/images/BrokenTeeth.png" alt="" />
);

export const DentifierLogo = () => (
  <img src="/images/DentifierLogo.png" alt="" />
);

export const FilterIcon = () => (
  <svg width="32" height="35" viewBox="0 0 32 35" fill="none">
    <circle
      cx="13.5648"
      cy="10.7826"
      r="1.78261"
      stroke="black"
      strokeWidth="2"
    />
    <circle
      cx="2.78261"
      cy="2.78261"
      r="1.78261"
      transform="matrix(-1 0 0 1 21.2178 14.9564)"
      stroke="black"
      strokeWidth="2"
    />
    <circle cx="13.5648" cy="24" r="1.78261" stroke="black" strokeWidth="2" />
    <path
      d="M8 10.7826H11.4783"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M24 17.739H20.5217"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M8 24H11.4783"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15.6523 10.7826H24.0002"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M16.3477 17.739H7.99983"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M15.6523 24H24.0002"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const GalleryViewIcon = () => (
  <svg width="32" height="33" viewBox="0 0 32 33" fill="none">
    <rect
      x="7.99414"
      y="8.39136"
      width="6.85714"
      height="6.85714"
      fill="#2C2B4F"
    />
    <rect
      x="17.1367"
      y="8.39136"
      width="6.85714"
      height="6.85714"
      fill="#2C2B4F"
    />
    <rect
      x="17.1367"
      y="17.5342"
      width="6.85714"
      height="6.85714"
      fill="#2C2B4F"
    />
    <rect
      x="7.99414"
      y="17.5342"
      width="6.85714"
      height="6.85714"
      fill="#2C2B4F"
    />
  </svg>
);

export const ListViewIcon = () => (
  <svg width="32" height="29" viewBox="0 0 32 29" fill="none">
    <g opacity="0.5">
      <circle cx="9.38544" cy="9.5218" r="1.3913" fill="#2C2B4F" />
      <circle cx="9.38544" cy="14.3913" r="1.3913" fill="#2C2B4F" />
      <circle cx="9.38544" cy="19.2609" r="1.3913" fill="#2C2B4F" />
      <path
        d="M12.8633 9.52185H23.9937"
        stroke="#2C2B4F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.8633 14.3914H23.9937"
        stroke="#2C2B4F"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.8633 19.261H23.9937"
        stroke="#2C2B4F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const SortIcon = () => (
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none">
    <line
      x1="8.99707"
      y1="7.39136"
      x2="22.9971"
      y2="7.39136"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="11.9971"
      y1="11.3914"
      x2="19.9971"
      y2="11.3914"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="13.9971"
      y1="15.3914"
      x2="17.9971"
      y2="15.3914"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const SuccessCheckmarkIcon = () => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none">
    <g filter="url(#filter0_d_252_31650)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29ZM22.6794 12.7338C23.0847 12.3585 23.109 11.7258 22.7338 11.3206C22.3585 10.9153 21.7258 10.891 21.3206 11.2662L14.1242 17.9295L10.7071 14.5124C10.3166 14.1219 9.68342 14.1219 9.29289 14.5124C8.90237 14.9029 8.90237 15.5361 9.29289 15.9266L13.3905 20.0242L14.0709 20.7046L14.777 20.0508L22.6794 12.7338Z"
        fill="#6EAF81"
      />
      <path
        d="M10 15.2195L14.0976 19.3171L22 12"
        stroke="#FEFEFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const CloseCheckmarkIcon = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM6.29301 6.29289C6.68354 5.90237 7.3167 5.90237 7.70723 6.29289L15.0003 13.586L22.2986 6.29265C22.6893 5.90226 23.3225 5.90248 23.7128 6.29314C24.1032 6.68379 24.103 7.31696 23.7124 7.70735L16.4145 15.0002L23.7017 22.2874C24.0923 22.6779 24.0923 23.3111 23.7017 23.7016C23.3112 24.0921 22.678 24.0921 22.2875 23.7016L14.9998 16.4139L7.70687 23.7019C7.31621 24.0922 6.68304 24.092 6.29265 23.7014C5.90226 23.3107 5.90248 22.6775 6.29314 22.2872L13.5856 14.9997L6.29301 7.70711C5.90249 7.31658 5.90249 6.68342 6.29301 6.29289Z"
        fill="#6EAF81"
      />
      <path
        d="M7.00012 7L22.9946 22.9945"
        stroke="#FEFEFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23.0055 7L7 22.9945"
        stroke="#FEFEFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const DropdownClear = () => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
    <g>
      <path
        d="M1.49707 1.39404L9.49158 9.38856"
        stroke="#FEFEFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        id="Line 22"
        d="M9.49707 1.39404L1.49707 9.38855"
        stroke="#FEFEFE"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const DropdownCheck = () => (
  <svg width="15" height="11" viewBox="0 0 15 11" fill="none">
    <g id="icon/tick">
      <path
        id="Vector 14"
        d="M1.49707 4.9523L5.59463 9.04986L13.4971 1.73279"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
};